import { Link } from "react-router-dom";

export default function HomeTrustStrip() {
  return (
    <section className="home-trust-strip" aria-label="Store guarantees">
      <ul className="home-trust-strip__list">
        <li>
          <strong>Secure checkout</strong>
          <span>UPI via SMEPay &amp; COD available</span>
        </li>
        <li>
          <strong>Tracked shipping</strong>
          <span>Rates at checkout across India</span>
        </li>
        <li>
          <Link to="/shipping">Shipping policy</Link>
        </li>
        <li>
          <Link to="/privacy">Privacy policy</Link>
        </li>
      </ul>
    </section>
  );
}
